// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/route_custom_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Route } from "./route_pb.js";
import { file_transportation_v1_route } from "./route_pb.js";
import { file_transportation_v1_service } from "./service_pb.js";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/route_custom_events.proto.
 */
export const file_transportation_v1_route_custom_events: GenFile = /*@__PURE__*/
  fileDesc("Cit0cmFuc3BvcnRhdGlvbi92MS9yb3V0ZV9jdXN0b21fZXZlbnRzLnByb3RvEhF0cmFuc3BvcnRhdGlvbi52MSJsChFSb3V0ZVN0YXJ0ZWRFdmVudBInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEi4KCnN0YXJ0X3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wInMKE1JvdXRlQ29tcGxldGVkRXZlbnQSJwoFcm91dGUYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZRIzCg9jb21wbGV0aW9uX3RpbWUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIk4KE1JvdXRlQ2FuY2VsbGVkRXZlbnQSJwoFcm91dGUYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZRIOCgZyZWFzb24YAiABKAkifQoQUm91dGVGYWlsZWRFdmVudBInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEjAKDGZhaWx1cmVfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDgoGcmVhc29uGAMgASgJItABChJSb3V0ZUFzc2lnbmVkRXZlbnQSJwoFcm91dGUYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZRIZChFhc3NpZ25tZW50X3N0YXR1cxgCIAEoCRIcCglkcml2ZXJfaWQYAyABKAsyCS50eXBlcy5JRBIcCgloYXVsZXJfaWQYBCABKAsyCS50eXBlcy5JRBIbCgh0cnVja19pZBgFIAEoCzIJLnR5cGVzLklEEh0KCnRyYWlsZXJfaWQYBiABKAsyCS50eXBlcy5JRCKNAQoUUm91dGVVbmFzc2lnbmVkRXZlbnQSJwoFcm91dGUYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Sb3V0ZRIlChJwcmV2aW91c19kcml2ZXJfaWQYAiABKAsyCS50eXBlcy5JRBIlChJwcmV2aW91c19oYXVsZXJfaWQYAyABKAsyCS50eXBlcy5JRCJaChNSb3V0ZVRhc2tBZGRlZEV2ZW50EicKBXJvdXRlGAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuUm91dGUSGgoHdGFza19pZBgCIAEoCzIJLnR5cGVzLklEIlwKFVJvdXRlVGFza1JlbW92ZWRFdmVudBInCgVyb3V0ZRgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlJvdXRlEhoKB3Rhc2tfaWQYAiABKAsyCS50eXBlcy5JREJBWj9wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFuc3BvcnRhdGlvbi9hcGkvdjE7dHJhbnNwb3J0YXRpb25fdjFiCGVkaXRpb25zcOgH", [file_google_protobuf_timestamp, file_transportation_v1_route, file_transportation_v1_service, file_types]);

/**
 * @generated from message transportation.v1.RouteStartedEvent
 */
export type RouteStartedEvent = Message<"transportation.v1.RouteStartedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;
};

/**
 * Describes the message transportation.v1.RouteStartedEvent.
 * Use `create(RouteStartedEventSchema)` to create a new message.
 */
export const RouteStartedEventSchema: GenMessage<RouteStartedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 0);

/**
 * @generated from message transportation.v1.RouteCompletedEvent
 */
export type RouteCompletedEvent = Message<"transportation.v1.RouteCompletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: google.protobuf.Timestamp completion_time = 2;
   */
  completionTime?: Timestamp;
};

/**
 * Describes the message transportation.v1.RouteCompletedEvent.
 * Use `create(RouteCompletedEventSchema)` to create a new message.
 */
export const RouteCompletedEventSchema: GenMessage<RouteCompletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 1);

/**
 * @generated from message transportation.v1.RouteCancelledEvent
 */
export type RouteCancelledEvent = Message<"transportation.v1.RouteCancelledEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message transportation.v1.RouteCancelledEvent.
 * Use `create(RouteCancelledEventSchema)` to create a new message.
 */
export const RouteCancelledEventSchema: GenMessage<RouteCancelledEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 2);

/**
 * @generated from message transportation.v1.RouteFailedEvent
 */
export type RouteFailedEvent = Message<"transportation.v1.RouteFailedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: google.protobuf.Timestamp failure_time = 2;
   */
  failureTime?: Timestamp;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message transportation.v1.RouteFailedEvent.
 * Use `create(RouteFailedEventSchema)` to create a new message.
 */
export const RouteFailedEventSchema: GenMessage<RouteFailedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 3);

/**
 * @generated from message transportation.v1.RouteAssignedEvent
 */
export type RouteAssignedEvent = Message<"transportation.v1.RouteAssignedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: string assignment_status = 2;
   */
  assignmentStatus: string;

  /**
   * @generated from field: types.ID driver_id = 3;
   */
  driverId?: ID;

  /**
   * @generated from field: types.ID hauler_id = 4;
   */
  haulerId?: ID;

  /**
   * @generated from field: types.ID truck_id = 5;
   */
  truckId?: ID;

  /**
   * @generated from field: types.ID trailer_id = 6;
   */
  trailerId?: ID;
};

/**
 * Describes the message transportation.v1.RouteAssignedEvent.
 * Use `create(RouteAssignedEventSchema)` to create a new message.
 */
export const RouteAssignedEventSchema: GenMessage<RouteAssignedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 4);

/**
 * @generated from message transportation.v1.RouteUnassignedEvent
 */
export type RouteUnassignedEvent = Message<"transportation.v1.RouteUnassignedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: types.ID previous_driver_id = 2;
   */
  previousDriverId?: ID;

  /**
   * @generated from field: types.ID previous_hauler_id = 3;
   */
  previousHaulerId?: ID;
};

/**
 * Describes the message transportation.v1.RouteUnassignedEvent.
 * Use `create(RouteUnassignedEventSchema)` to create a new message.
 */
export const RouteUnassignedEventSchema: GenMessage<RouteUnassignedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 5);

/**
 * @generated from message transportation.v1.RouteTaskAddedEvent
 */
export type RouteTaskAddedEvent = Message<"transportation.v1.RouteTaskAddedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: types.ID task_id = 2;
   */
  taskId?: ID;
};

/**
 * Describes the message transportation.v1.RouteTaskAddedEvent.
 * Use `create(RouteTaskAddedEventSchema)` to create a new message.
 */
export const RouteTaskAddedEventSchema: GenMessage<RouteTaskAddedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 6);

/**
 * @generated from message transportation.v1.RouteTaskRemovedEvent
 */
export type RouteTaskRemovedEvent = Message<"transportation.v1.RouteTaskRemovedEvent"> & {
  /**
   * @generated from field: transportation.v1.Route route = 1;
   */
  route?: Route;

  /**
   * @generated from field: types.ID task_id = 2;
   */
  taskId?: ID;
};

/**
 * Describes the message transportation.v1.RouteTaskRemovedEvent.
 * Use `create(RouteTaskRemovedEventSchema)` to create a new message.
 */
export const RouteTaskRemovedEventSchema: GenMessage<RouteTaskRemovedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_route_custom_events, 7);

